import * as i0 from '@angular/core';
import { Component, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';

class LoadingScreenComponent {
    constructor() {
        this.isLoading = false;
        this.showlogo = true;
        this.UrlLogo = 'https://ddrjriz9ccm55.cloudfront.net/loading-sel-sura.gif';
    }
}
LoadingScreenComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoadingScreenComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LoadingScreenComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LoadingScreenComponent, selector: "sura-loading-screen", inputs: { isLoading: "isLoading", showlogo: "showlogo", UrlLogo: "UrlLogo" }, ngImport: i0, template: "<div *ngIf=\"isLoading\">\n  <div class=\"custom-modal-message__backdrop\"></div>\n  <div class=\"custom-modal-message__container\">\n    <img [src]=\"UrlLogo\" *ngIf=\"showlogo\" />\n    <p class=\"custom-modal-message__message\">Cargando...</p>\n  </div>\n</div>\n", styles: [".custom-modal-message__container,.custom-modal-message__backdrop{background:rgba(255,255,255,.7);position:fixed;top:0;right:0;bottom:0;left:0;display:flex;justify-content:center;align-items:center;flex-direction:column;z-index:1050}.custom-modal-message__message{margin:0;font-size:1.5rem}\n"], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoadingScreenComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'sura-loading-screen',
                    templateUrl: './loading-screen.component.html',
                    styleUrls: ['./loading-screen.component.scss'],
                }]
        }], propDecorators: { isLoading: [{
                type: Input
            }], showlogo: [{
                type: Input
            }], UrlLogo: [{
                type: Input
            }] } });

var SkeletonFigure;
(function (SkeletonFigure) {
    SkeletonFigure["RECTANGLE"] = "rectangle";
    SkeletonFigure["CIRCLE"] = "circle";
    SkeletonFigure["BUTTON"] = "button";
    SkeletonFigure["LIST"] = "list";
})(SkeletonFigure || (SkeletonFigure = {}));

var SkeletonAlign;
(function (SkeletonAlign) {
    SkeletonAlign["CENTER"] = "center";
    SkeletonAlign["RIGHT"] = "right";
})(SkeletonAlign || (SkeletonAlign = {}));

class LibSuraSkeletonComponent {
    constructor() {
        this.RECTANGLE = SkeletonFigure.RECTANGLE;
        this.CIRCLE = SkeletonFigure.CIRCLE;
        this.BUTTON = SkeletonFigure.BUTTON;
        this.LIST = SkeletonFigure.LIST;
        this.ALIGN_CENTER = 'center';
        this.ALIGN_RIGHT = 'right';
        this.listItemsQuantity = 4;
    }
}
LibSuraSkeletonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibSuraSkeletonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
LibSuraSkeletonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: LibSuraSkeletonComponent, selector: "lib-sura-skeleton", inputs: { figure: "figure", width: "width", height: "height", loading: "loading", align: "align", listItemsQuantity: "listItemsQuantity" }, ngImport: i0, template: "<div\n  class=\"skeleton\"\n  [class.skeleton_center]=\"align === ALIGN_CENTER\"\n  [class.skeleton_right]=\"align === ALIGN_RIGHT\"\n  *ngIf=\"loading\"\n>\n  <div\n    *ngIf=\"figure === RECTANGLE\"\n    [style.width]=\"width\"\n    [style.height]=\"height\"\n    class=\"skeleton__rectangle skeleton__loading\"\n  ></div>\n  <div\n    *ngIf=\"figure === CIRCLE\"\n    [style.width]=\"width\"\n    [style.height]=\"height\"\n    class=\"skeleton__circle skeleton__loading\"\n  ></div>\n  <div\n    *ngIf=\"figure === BUTTON\"\n    [style.width]=\"width\"\n    [style.height]=\"height\"\n    class=\"skeleton__button skeleton__loading\"\n  ></div>\n  <ul class=\"skeleton__list\" *ngIf=\"figure === LIST\">\n    <li\n      *ngFor=\"let item of [].constructor(listItemsQuantity)\"\n      [style.width]=\"width\"\n      [style.height]=\"height\"\n      class=\"skeleton__loading skeleton__item\"\n    ></li>\n  </ul>\n</div>\n", styles: [".skeleton{display:flex}.skeleton_center{justify-content:center}.skeleton_right{justify-content:flex-end}.skeleton__list{position:relative;overflow:hidden;list-style:none;padding:0}.skeleton__item{overflow:hidden;border-radius:.3125rem;margin-top:.3125rem;width:100%;height:.625rem}.skeleton__button{border-radius:1.875rem;height:2.5rem;width:100%;overflow:hidden}.skeleton__circle{border-radius:50%;height:12.5rem;width:100%;overflow:hidden}.skeleton__rectangle{height:2.5rem;width:100%;overflow:hidden}.skeleton__loading{background-color:#d0d0d0;position:relative;overflow:hidden}.skeleton__loading:after{display:block;content:\"\";position:absolute;width:100%;height:100%;transform:translate(-100%);background:linear-gradient(90deg,transparent,rgba(255,255,255,.25),transparent);animation:loading 2s infinite}@keyframes loading{to{transform:translate(100%)}}\n"], directives: [{ type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LibSuraSkeletonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-sura-skeleton',
                    templateUrl: './lib-sura-skeleton.component.html',
                    styleUrls: ['./lib-sura-skeleton.component.scss'],
                }]
        }], propDecorators: { figure: [{
                type: Input
            }], width: [{
                type: Input
            }], height: [{
                type: Input
            }], loading: [{
                type: Input
            }], align: [{
                type: Input
            }], listItemsQuantity: [{
                type: Input
            }] } });

class LoadingScreenModule {
}
LoadingScreenModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoadingScreenModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
LoadingScreenModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoadingScreenModule, declarations: [LoadingScreenComponent, LibSuraSkeletonComponent], imports: [CommonModule], exports: [LoadingScreenComponent, LibSuraSkeletonComponent] });
LoadingScreenModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoadingScreenModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: LoadingScreenModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [LoadingScreenComponent, LibSuraSkeletonComponent],
                    exports: [LoadingScreenComponent, LibSuraSkeletonComponent],
                    imports: [CommonModule],
                }]
        }] });

// Modulo general

/**
 * Generated bundle index. Do not edit.
 */

export { LibSuraSkeletonComponent, LoadingScreenComponent, LoadingScreenModule, SkeletonAlign, SkeletonFigure };
